const SmallStar = ({ className, color = "#FFD21F" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path d="M12 2l2.9 6.3 6.9.7-5.2 4.6 1.5 6.8L12 17l-6.1 3.4 1.5-6.8L2.2 9l6.9-.7z" fill={color} />
  </svg>
);

export const SkyDecor = () => (
  <div className="pointer-events-none fixed inset-0 overflow-hidden -z-0" aria-hidden="true">
    <div className="absolute -right-24 top-24 w-80 h-80 rounded-full opacity-60"
      style={{ background: "radial-gradient(circle, transparent 52%, #F0303A 52%, #F0303A 57%, #FF8A1F 57%, #FF8A1F 62%, #FFD21F 62%, #FFD21F 67%, #4CC417 67%, #4CC417 72%, #38B6FF 72%, #38B6FF 77%, #8A3FE0 77%, #8A3FE0 82%, transparent 82%)" }} />
    <div className="cloud-shape anim-drift" style={{ width: 160, height: 44, top: 90, left: -30 }} />
    <div className="cloud-shape anim-drift" style={{ width: 200, height: 52, top: "55%", right: -60, animationDelay: "-5s" }} />
    <div className="cloud-shape" style={{ width: 240, height: 60, bottom: 30, left: "10%", opacity: 0.75 }} />
    <div className="bubble anim-float" style={{ width: 46, height: 46, top: "30%", left: "6%" }} />
    <div className="bubble anim-float" style={{ width: 28, height: 28, top: "70%", left: "82%", animationDelay: "-2s" }} />
    <div className="bubble anim-float" style={{ width: 64, height: 64, top: "82%", left: "60%", animationDelay: "-1s" }} />
    <SmallStar className="absolute w-6 h-6 top-40 right-16 anim-wiggle" />
    <SmallStar className="absolute w-4 h-4 top-[60%] left-10" color="#FF5FA8" />
    <SmallStar className="absolute w-5 h-5 bottom-40 right-1/3 anim-wiggle" color="#fff" />
  </div>
);
